import { isPhoneWorkspace, readDisplayState } from '@/views/mobile/shared/displayState'
import i18n from '@/locales/i18n'

/**
 * 通用图片预览器组件
 * 从 CustomImage.js 提取并独立封装
 */

export const ZOOM_IN = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.057 15.996l2.981 2.982a.375.375 0 010 .53l-.53.53a.375.375 0 01-.53 0l-2.982-2.981a7.5 7.5 0 111.06-1.06zM10.5 10.5V8.625a.375.375 0 01.375-.375h.75a.375.375 0 01.375.375V10.5h1.875a.376.376 0 01.375.375v.75a.376.376 0 01-.375.375H12v1.875a.376.376 0 01-.375.375h-.75a.375.375 0 01-.375-.375V12H8.625a.375.375 0 01-.375-.375v-.75a.375.375 0 01.375-.375H10.5zm.75 6.75a6 6 0 100-12 6 6 0 000 12z" fill="#fff"></path></svg>'
export const ZOOM_OUT = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.057 15.996l2.981 2.982a.375.375 0 010 .53l-.53.53a.375.375 0 01-.53 0l-2.982-2.981a7.5 7.5 0 111.06-1.06zM11.25 17.25a6 6 0 100-12 6 6 0 000 12zM8.625 10.5h5.25a.376.376 0 01.375.375v.75a.376.376 0 01-.375.375h-5.25a.375.375 0 01-.375-.375v-.75a.375.375 0 01.375-.375z" fill="#fff"></path></svg>'
export const FIT_SCREEN_ICON_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4.875 14.25a.375.375 0 01.375.375v2.625h2.625a.376.376 0 01.375.375v.75a.375.375 0 01-.375.375H4.5a.75.75 0 01-.75-.75v-3.375a.375.375 0 01.375-.375h.75zm15 0a.375.375 0 01.375.375V18a.75.75 0 01-.75.75h-3.375a.376.376 0 01-.375-.375v-.75a.376.376 0 01.375-.375h2.625v-2.625a.376.376 0 01.375-.375h.75zm-3.375-6a.75.75 0 01.75.75v6a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V9a.75.75 0 01.75-.75h9zm-.75 1.5h-7.5v4.5h7.5v-4.5zm-7.875-4.5a.375.375 0 01.375.375v.75a.375.375 0 01-.375.375H5.25v2.625a.375.375 0 01-.375.375h-.75a.375.375 0 01-.375-.375V6a.75.75 0 01.75-.75h3.375zm11.625 0a.75.75 0 01.75.75v3.375a.376.376 0 01-.375.375h-.75a.375.375 0 01-.375-.375V6.75h-2.625a.375.375 0 01-.375-.375v-.75a.376.376 0 01.375-.375H19.5z" fill="#fff"></path></svg>'
export const ORIGINAL_SIZE_ICON_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.675 5H4.825C4.369 5 4 5.356 4 5.794v11.912c0 .439.37.794.825.794h14.85c.456 0 .825-.355.825-.794V5.794c0-.438-.37-.794-.825-.794zM5.5 17V6.5H19V17H5.5zm6-4.5H13V14h-1.5v-1.5zm1.5-3h-1.5V11H13V9.5zm-5.72 1.198a.188.188 0 01-.28-.163v-.936c0-.135.073-.26.19-.327l.842-.474a.375.375 0 01.184-.048H9.25c.207 0 .375.168.375.375v5.25a.375.375 0 01-.375.375h-.757a.375.375 0 01-.375-.375v-4.154l-.838.477zm7.22-.163c0 .144.155.234.28.163l.838-.477v4.154c0 .207.168.375.375.375h.757a.375.375 0 00.375-.375v-5.25a.375.375 0 00-.375-.375h-1.034a.375.375 0 00-.184.048l-.841.474a.375.375 0 00-.191.327v.936z" fill="#fff"></path> </svg>'
export const ROTATE_LEFT = '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24" fill="white"><path d="M5.89 7.5H8.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H2.25c-.83 0-1.5-.67-1.5-1.5V3c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v2.4l.82-.82c4.1-4.1 10.73-4.1 14.83 0s4.1 10.73 0 14.83-10.73 4.1-14.83 0c-.58-.58-.58-1.53 0-2.12.58-.58 1.53-.58 2.12 0 2.92 2.92 7.67 2.92 10.6 0s2.92-7.67 0-10.6c-2.92-2.92-7.67-2.92-10.6 0l.84.84z"/></svg>'
export const ROTATE_RIGHT = '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24" fill="white"><path d="M18.11 7.5H15.75c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v2.4l-.82-.82c-4.1-4.1-10.73-4.1-14.83 0s-4.1 10.73 0 14.83 10.73 4.1 14.83 0c.58-.58.58-1.53 0-2.12-.58-.58-1.53-.58-2.12 0-2.92 2.92-7.67 2.92-10.6 0s-2.92-7.67 0-10.6c2.92-2.92 7.67-2.92 10.6 0l-.84.84z"/></svg>'
export const DOWNLOAD = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18.75 16.875v1.875a.75.75 0 01-.75.75H6a.75.75 0 01-.75-.75v-1.875c0-.207.168-.375.375-.375h.75c.207 0 .375.168.375.375V18h10.5v-1.125c0-.207.168-.375.375-.375h.75c.207 0 .375.168.375.375zm-6-3.348l2.258-2.258a.375.375 0 01.53 0l.53.53a.375.375 0 010 .53l-3.712 3.713a.374.374 0 01-.53 0L8.114 12.33a.375.375 0 010-.53l.53-.531a.375.375 0 01.53 0l2.076 2.076V5.25c0-.207.168-.375.375-.375h.75c.207 0 .375.168.375.375v8.277z" fill="#fff"></path></svg>'

const DEFAULT_LABELS = {
  close: '关闭',
  zoomOut: '缩小',
  zoomIn: '放大',
  originalSize: '原始尺寸',
  fitToScreen: '适应屏幕',
  rotateLeft: '向左旋转',
  rotateRight: '向右旋转',
  previous: '上一张',
  next: '下一张',
  download: '下载'
}

function normalizeLabels(labels = {}) {
  return {
    ...DEFAULT_LABELS,
    close: i18n.global.t('components.vueblocknote.close'),
    zoomOut: i18n.global.t('components.vueblocknote.zoom_out'),
    zoomIn: i18n.global.t('components.vueblocknote.zoom_in'),
    originalSize: i18n.global.t('components.vueblocknote.original_size'),
    fitToScreen: i18n.global.t('components.vueblocknote.fit_to_screen'),
    rotateLeft: i18n.global.t('components.vueblocknote.rotate_left'),
    rotateRight: i18n.global.t('components.vueblocknote.rotate_right'),
    previous: i18n.global.t('views.image_generation.previous_case'),
    next: i18n.global.t('views.image_generation.next_case'),
    download: i18n.global.t('components.vueblocknote.download_image'),
    loading: i18n.global.t('views.attachment.loading_preview'),
    failed: i18n.global.t('views.attachment.preview_failed'),
    retry: i18n.global.t('views.attachment.preview_retry'),
    ...labels
  }
}

/**
 * 创建通用图片预览器
 * @param {Object} options 配置选项
 * @param {string} options.containerId 容器ID (可选，默认使用全局容器)
 * @param {Function} options.onDownload 下载回调函数 (可选)
 * @param {Function} options.onClose 关闭回调函数 (可选)
 * @returns {Object} 预览器实例
 */
export function createImageViewer(options = {}) {
  const { containerId = 'universal-image-viewer', onDownload, onClose, onLoad, onError, onSwitch, onRetry, labels } = options

  // 防止重复初始化
  if (window[`imageViewer_${containerId}`]) {
    const existingViewer = window[`imageViewer_${containerId}`]
    if (existingViewer.setLabels && labels) {
      existingViewer.setLabels(labels)
    }
    if (existingViewer.setOnDownload) {
      existingViewer.setOnDownload(onDownload)
    }
    return existingViewer
  }

  let viewerLabels = normalizeLabels(labels)
  let downloadHandler = onDownload
  const listeners = []
  const listen = (target, event, handler, options) => {
    target.addEventListener(event, handler, options)
    listeners.push(() => target.removeEventListener(event, handler, options))
  }
  const isMobileViewer = () => {
    const display = readDisplayState()
    return display.layoutMode === 'mobile' || isPhoneWorkspace(display)
  }

  // 创建样式
  const style = document.createElement('style')
  style.textContent = `
    /* 通用图片预览器样式 */
    .universal-image-viewer-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.85);
      z-index: 10000;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    }

    .universal-image-viewer-container {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;  
      flex-direction: column;
      overflow: hidden;
    }

    .universal-image-content {
      cursor: zoom-out;
      width: 100%;
      height: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      overflow: hidden;
    }

    .universal-preview-image {
      max-width: 100%;
      max-height: 100%;
      transform-origin: center;
      cursor: grab;
      user-select: none;
    }

    .universal-preview-image:active {
      cursor: grabbing;
    }

    .universal-close-button {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 36px;
      height: 36px;
      background-color: rgba(0, 0, 0, 0.5);
      border: none;
      border-radius: 50%;
      color: white;
      font-size: 18px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      transition: background-color 0.2s;
    }

    .universal-close-button:hover {
      background-color: rgba(0, 0, 0, 0.7);
    }

    .universal-navigation-button {
      position: absolute;
      top: 50%;
      width: 48px;
      height: 48px;
      padding: 0;
      border: none;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      cursor: pointer;
      display: none;
      align-items: center;
      justify-content: center;
      z-index: 10;
      transform: translateY(-50%);
      transition: background-color 0.2s;
    }

    .universal-navigation-button svg {
      display: block;
      width: 24px;
      height: 24px;
      flex: 0 0 24px;
    }

    .universal-navigation-button:hover {
      background-color: rgba(0, 0, 0, 0.75);
    }

    .universal-navigation-previous {
      left: 24px;
    }

    .universal-navigation-next {
      right: 24px;
    }

    .universal-image-toolbar-container {
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .universal-image-toolbar {
      height: 48px;
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      user-select: none;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .universal-toolbar-left, .universal-toolbar-right {
      width: 10px;
    }

    .universal-toolbar-center {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .universal-toolbar-button {
      background: transparent;
      border: none;
      color: white;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;
      font-size: 18px;
      margin: 0 2px;
      transition: background-color 0.2s;
    }

    .universal-toolbar-button:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .universal-toolbar-divider {
      width: 1px;
      height: 16px;
      background-color: rgba(255, 255, 255, 0.2);
      margin: 0 8px;
    }

    .universal-zoom-level {
      color: white;
      font-size: 14px;
      margin: 0 8px;
      width: 48px;
      text-align: center;
    }
    
    .universal-toolbar-button {
      position: relative;
    }
    
    .universal-toolbar-button[data-tooltip]:hover::after {
      content: attr(data-tooltip);
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding: 5px 10px;
      background: rgba(222, 224, 227);
      color: black;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      margin-bottom: 5px;
    }

    .universal-image-viewer-overlay.is-mobile-viewer {
      background: #17191d;
      box-sizing: border-box;
      touch-action: pan-x;
      padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
    }
    .is-mobile-viewer .universal-image-viewer-container { min-height: 0; }
    .is-mobile-viewer .universal-preview-image { flex: 0 0 auto; }
    .universal-image-status { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 16px; padding: 16px; color: #fff; text-align: center; pointer-events: none; }
    .universal-image-status[hidden] { display: none; }
    .universal-image-retry { min-height: 44px; padding: 8px 20px; border: 1px solid #fff; border-radius: 8px; background: transparent; color: #fff; cursor: pointer; pointer-events: auto; }
    .is-mobile-viewer .universal-image-content {
      touch-action: none;
      box-sizing: border-box;
      flex: 1 1 0;
      min-height: 0;
      width: 100%;
      padding: 0 12px;
      margin-top: 56px;
    }
    .is-mobile-viewer.has-image-navigation .universal-image-content { padding-inline: 60px; }
    .is-mobile-viewer .universal-close-button { top: 6px; right: 8px; width: 44px; height: 44px; }
    .is-mobile-viewer .universal-navigation-button { width: 44px; height: 44px; }
    .is-mobile-viewer .universal-navigation-previous { left: 8px; }
    .is-mobile-viewer .universal-navigation-next { right: 8px; }
    .is-mobile-viewer .universal-image-toolbar-container {
      position: relative;
      bottom: auto;
      height: auto;
      flex: 0 0 auto;
      width: 100%;
      box-sizing: border-box;
      padding: 8px;
    }
    .is-mobile-viewer .universal-image-toolbar {
      width: 100%;
      max-width: 440px;
      height: auto;
      min-height: 48px;
      box-sizing: border-box;
      padding: 2px;
      overflow-x: auto;
      scrollbar-width: none;
      touch-action: pan-x;
    }
    .is-mobile-viewer .universal-toolbar-center { flex: 1; justify-content: space-between; gap: 0; }
    .is-mobile-viewer .universal-toolbar-button { flex: 0 0 44px; width: 44px; height: 44px; margin: 0; padding: 0; }
    .is-mobile-viewer .universal-toolbar-divider,
    .is-mobile-viewer .universal-toolbar-left,
    .is-mobile-viewer .universal-toolbar-right { display: none; }
    .is-mobile-viewer .universal-zoom-level { flex: 0 0 32px; width: 32px; margin: 0; font-size: 12px; }
    .is-mobile-viewer .universal-toolbar-button[data-tooltip]:hover::after { display: none; }
  `
  document.head.appendChild(style)

  // 创建DOM结构
  const overlay = document.createElement('div')
  overlay.className = 'universal-image-viewer-overlay'
  overlay.id = containerId
  overlay.setAttribute('role', 'dialog')
  overlay.setAttribute('aria-modal', 'true')
  overlay.tabIndex = -1

  const container = document.createElement('div')
  container.className = 'universal-image-viewer-container'

  const closeButton = document.createElement('button')
  closeButton.className = 'universal-close-button'
  closeButton.innerHTML = '✕'
  closeButton.setAttribute('title', viewerLabels.close)
  closeButton.setAttribute('aria-label', viewerLabels.close)

  const previousButton = document.createElement('button')
  previousButton.className = 'universal-navigation-button universal-navigation-previous'
  previousButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  previousButton.setAttribute('title', viewerLabels.previous)
  previousButton.setAttribute('aria-label', viewerLabels.previous)

  const nextButton = document.createElement('button')
  nextButton.className = 'universal-navigation-button universal-navigation-next'
  nextButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  nextButton.setAttribute('title', viewerLabels.next)
  nextButton.setAttribute('aria-label', viewerLabels.next)

  const imageContent = document.createElement('div')
  imageContent.className = 'universal-image-content'

  const image = document.createElement('img')
  image.className = 'universal-preview-image'
  const status = document.createElement('div')
  status.className = 'universal-image-status'
  status.setAttribute('role', 'status')
  status.hidden = true
  const statusText = document.createElement('span')
  const retryButton = document.createElement('button')
  retryButton.className = 'universal-image-retry'
  retryButton.type = 'button'
  retryButton.textContent = viewerLabels.retry || viewerLabels.fitToScreen
  retryButton.hidden = true
  status.appendChild(statusText)
  status.appendChild(retryButton)

  const toolbar = document.createElement('div')
  toolbar.className = 'universal-image-toolbar-container'

  // 创建工具栏内容
  toolbar.innerHTML = `
    <div class="universal-image-toolbar">
        <div class="universal-toolbar-left"></div>
        <div class="universal-toolbar-center">
          <button class="universal-toolbar-button universal-zoom-out" data-tooltip="${viewerLabels.zoomOut}">${ZOOM_OUT}</button>
          <span class="universal-zoom-level">100%</span>
          <button class="universal-toolbar-button universal-zoom-in" data-tooltip="${viewerLabels.zoomIn}">${ZOOM_IN}</button>
          <div class="universal-toolbar-divider"></div>
          <button class="universal-toolbar-button universal-fit-screen" data-tooltip="${viewerLabels.originalSize}">${ORIGINAL_SIZE_ICON_SVG}</button>
          <div class="universal-toolbar-divider"></div>
          <button class="universal-toolbar-button universal-rotate-left" data-tooltip="${viewerLabels.rotateLeft}">${ROTATE_LEFT}</button>
          <button class="universal-toolbar-button universal-rotate-right" data-tooltip="${viewerLabels.rotateRight}">${ROTATE_RIGHT}</button>
          <div class="universal-toolbar-divider"></div>
          <button class="universal-toolbar-button universal-download" data-tooltip="${viewerLabels.download}">${DOWNLOAD}</button>
        </div>
        <div class="universal-toolbar-right"></div>
    </div>
  `

  // 组装DOM
  imageContent.appendChild(image)
  imageContent.appendChild(status)
  container.appendChild(closeButton)
  container.appendChild(previousButton)
  container.appendChild(nextButton)
  container.appendChild(imageContent)
  container.appendChild(toolbar)
  overlay.appendChild(container)
  document.body.appendChild(overlay)

  // 获取相关元素
  const zoomOutBtn = toolbar.querySelector('.universal-zoom-out')
  const zoomInBtn = toolbar.querySelector('.universal-zoom-in')
  const zoomLevelSpan = toolbar.querySelector('.universal-zoom-level')
  const fitSwitchBtn = toolbar.querySelector('.universal-fit-screen')
  const rotateLeftBtn = toolbar.querySelector('.universal-rotate-left')
  const rotateRightBtn = toolbar.querySelector('.universal-rotate-right')
  const downloadBtn = toolbar.querySelector('.universal-download')

  // 状态变量
  let model = 1 // 1为适应屏幕，2为原始大小
  let modelTitle = viewerLabels.originalSize
  let scale = 1 // 当前缩放
  let imageRatio = 1 // 图片宽高比
  let rotation = 0
  let translateX = 0
  let translateY = 0
  let isDragging = false
  let startX, startY
  let currentImageSrc = ''
  let currentImageIndex = 0
  let viewerImages = []
  let previousOverflow = null
  let returnFocus = null
  let resizeTimeout
  const touches = new Map()

  function updateViewport() {
    const viewport = window.visualViewport
    overlay.classList.toggle('is-mobile-viewer', isMobileViewer())
    if (isMobileViewer()) {
      overlay.style.top = `${viewport?.offsetTop || 0}px`
      overlay.style.left = `${viewport?.offsetLeft || 0}px`
      overlay.style.width = `${viewport?.width || window.innerWidth}px`
      overlay.style.height = `${viewport?.height || window.innerHeight}px`
    } else {
      overlay.style.top = '0'
      overlay.style.left = '0'
      overlay.style.width = '100%'
      overlay.style.height = '100%'
    }
  }

  // 更新图片变换
  function updateTransform() {
    image.style.transform = `translate(${translateX}px, ${translateY}px) rotate(${rotation}deg) scale(${scale})`
    zoomLevelSpan.textContent = `${Math.round(scale * 100)}%`
  }

  // 适应屏幕
  function fitToScreen() {
    if (!image.complete) return

    const contentStyle = window.getComputedStyle(imageContent)
    const containerWidth = imageContent.clientWidth - parseFloat(contentStyle.paddingLeft || 0) - parseFloat(contentStyle.paddingRight || 0)
    const containerHeight = imageContent.clientHeight

    const imgWidth = image.naturalWidth
    const imgHeight = image.naturalHeight
    if (!imgWidth || !imgHeight || containerWidth <= 0 || containerHeight <= 0) return
    if (isMobileViewer()) {
      const quarterTurn = Math.abs(rotation % 180) === 90
      const rotatedWidth = quarterTurn ? imgHeight : imgWidth
      const rotatedHeight = quarterTurn ? imgWidth : imgHeight
      // 图片按原始像素缩放，初始同时满足可见宽高，避免 CSS 限宽后再缩放两次。
      image.style.width = `${imgWidth}px`
      image.style.height = `${imgHeight}px`
      image.style.maxWidth = 'none'
      image.style.maxHeight = 'none'
      scale = Math.min(containerWidth / rotatedWidth, containerHeight / rotatedHeight, 1)
      translateX = 0
      translateY = 0
      updateTransform()
      return
    }
    image.style.width = ''
    image.style.height = ''
    image.style.maxWidth = ''
    image.style.maxHeight = ''
    const lowerThreshold = 0.2 // 下限阈值 (20%)
    const upperThreshold = 0.6 // 上限阈值 (60%)
    const maxEnlarge = 0.2 // 最大放大比例 (20%)
    const maxShrink = 0.1 // 最大缩小比例 (10%)
    const smoothFactor = 0.5 // 平滑因子

    // 计算图片宽高比
    imageRatio = imgWidth / imgHeight

    // 图片占容器宽度高度比例
    const imgConWidthRatio = imgWidth / containerWidth
    const imgConHeightRatio = imgHeight / containerHeight

    // 实际缩放比例
    let fitScale = 1
    // 计算缩放比例
    const scaleX = calculateDimensionScale(imgConWidthRatio, lowerThreshold, upperThreshold, maxEnlarge, maxShrink, smoothFactor)
    const scaleY = calculateDimensionScale(imgConHeightRatio, lowerThreshold, upperThreshold, maxEnlarge, maxShrink, smoothFactor)

    if (scaleX > 1 && scaleY > 1) {
      // 都需要放大时，取较小值
      fitScale = Math.min(scaleX, scaleY)
    } else if (scaleX < 1 && scaleY < 1) {
      // 都需要缩小时，取较大值
      fitScale = Math.max(scaleX, scaleY)
    } else {
      // 一个放大一个缩小时，保持原尺寸
      fitScale = 1
    }

    translateX = 0
    translateY = 0
    scale = fitScale

    updateTransform()
  }

  // 计算单个维度的缩放比例
  function calculateDimensionScale(ratio, lowerThreshold, upperThreshold, maxEnlarge, maxShrink, smoothFactor) {
    if (ratio < lowerThreshold) {
      // 小于下限时放大
      const deficit = lowerThreshold / ratio
      const enlargeRatio = Math.min(maxEnlarge, (deficit - 1) * smoothFactor)
      return 1 + enlargeRatio
    } else if (ratio > upperThreshold) {
      // 大于上限时缩小
      const excess = ratio / upperThreshold
      const shrinkRatio = Math.min(maxShrink, (excess - 1) * smoothFactor)
      return 1 - shrinkRatio
    }
    return 1 // 在范围内保持原尺寸
  }

  // 重置为原始大小
  function resetToOriginal() {
    scale = 1
    translateX = 0
    translateY = 0
    updateTransform()
  }

  // 切换适应模式
  function fitSwitch() {
    if (model === 1) {
      resetToOriginal()
      model = 2
      modelTitle = viewerLabels.fitToScreen
    } else {
      fitToScreen()
      model = 1
      modelTitle = viewerLabels.originalSize
    }
    fitSwitchBtn.dataset.tooltip = modelTitle
    fitSwitchBtn.innerHTML = model === 1 ? ORIGINAL_SIZE_ICON_SVG : FIT_SCREEN_ICON_SVG
    fitSwitchBtn.setAttribute('aria-label', modelTitle)
  }

  // 缩放函数
  function zoomIn() {
    scale = Math.min(scale * 1.2, 5) // 限制最大缩放
    updateTransform()
  }

  function zoomOut() {
    scale = Math.max(scale / 1.2, isMobileViewer() ? 0.01 : 0.1)
    updateTransform()
  }

  // 旋转函数
  function rotateLeft() {
    if (translateX !== 0 || translateY !== 0) {
      const curRotation = rotation
      initImageStatus()
      rotation = curRotation
    }
    rotation -= 90
    if (isMobileViewer() && model === 1) fitToScreen()
    updateTransform()
  }

  function rotateRight() {
    if (translateX !== 0 || translateY !== 0) {
      const curRotation = rotation
      initImageStatus()
      rotation = curRotation
    }
    rotation += 90
    if (isMobileViewer() && model === 1) fitToScreen()
    updateTransform()
  }

  // 初始化图片状态
  function initImageStatus(shouldFit = true) {
    model = 1 // 1为适应屏幕，2为原始大小
    modelTitle = '原始尺寸'
    scale = 1 // 当前缩放
    imageRatio = 1 // 图片宽高比
    rotation = 0
    translateX = 0
    translateY = 0
    isDragging = false
    modelTitle = viewerLabels.originalSize
    fitSwitchBtn.dataset.tooltip = modelTitle
    fitSwitchBtn.innerHTML = ORIGINAL_SIZE_ICON_SVG
    fitSwitchBtn.setAttribute('aria-label', modelTitle)
    if (shouldFit) {
      fitToScreen()
    } else {
      updateTransform()
    }
  }

  function setLabels(nextLabels = {}) {
    viewerLabels = normalizeLabels(nextLabels)
    closeButton.setAttribute('title', viewerLabels.close)
    closeButton.setAttribute('aria-label', viewerLabels.close)
    zoomOutBtn.dataset.tooltip = viewerLabels.zoomOut
    zoomInBtn.dataset.tooltip = viewerLabels.zoomIn
    rotateLeftBtn.dataset.tooltip = viewerLabels.rotateLeft
    rotateRightBtn.dataset.tooltip = viewerLabels.rotateRight
    downloadBtn.dataset.tooltip = viewerLabels.download
    previousButton.setAttribute('title', viewerLabels.previous)
    previousButton.setAttribute('aria-label', viewerLabels.previous)
    nextButton.setAttribute('title', viewerLabels.next)
    nextButton.setAttribute('aria-label', viewerLabels.next)
    retryButton.textContent = viewerLabels.retry
    modelTitle = model === 1 ? viewerLabels.originalSize : viewerLabels.fitToScreen
    fitSwitchBtn.dataset.tooltip = modelTitle
    for (const button of toolbar.querySelectorAll('button[data-tooltip]')) button.setAttribute('aria-label', button.dataset.tooltip)
  }

  function setOnDownload(handler) {
    downloadHandler = handler
  }

  // 下载函数
  function downloadImage() {
    if (!currentImageSrc) return
    try {
      if (typeof downloadHandler === 'function') {
        Promise.resolve(downloadHandler(currentImageSrc)).catch(error => console.error('下载图片失败:', error))
      } else {
        const link = document.createElement('a')
        link.href = currentImageSrc
        link.download = currentImageSrc.split('/').pop() || 'image'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    } catch (error) {
      console.error('下载图片失败:', error)
    }
  }

  // 绑定拖拽事件
  function initDragEvents() {
    listen(image, 'click', (event) => {
      event.stopPropagation()
    })
    
    listen(image, 'mousedown', function(e) {
      if (e.button !== 0) return // 只响应左键
      isDragging = true
      startX = e.clientX - translateX
      startY = e.clientY - translateY
      image.style.cursor = 'grabbing'
      e.preventDefault()
    })

    listen(document, 'mousemove', function(e) {
      if (!isDragging) return
      translateX = e.clientX - startX
      translateY = e.clientY - startY
      updateTransform()
    })

    listen(document, 'mouseup', function() {
      if (isDragging) {
        isDragging = false
        image.style.cursor = 'grab'
      }
    })

    let pinchDistance = 0
    let pinchScale = 1
    listen(imageContent, 'pointerdown', event => {
      if (!isMobileViewer() || event.pointerType === 'mouse' || event.target.closest?.('button')) return
      event.preventDefault()
      if (imageContent.hasPointerCapture && !imageContent.hasPointerCapture(event.pointerId)) {
        imageContent.setPointerCapture(event.pointerId)
      }
      touches.set(event.pointerId, { x: event.clientX, y: event.clientY })
      if (touches.size === 1) {
        startX = event.clientX - translateX
        startY = event.clientY - translateY
      } else if (touches.size === 2) {
        const [first, second] = [...touches.values()]
        pinchDistance = Math.hypot(first.x - second.x, first.y - second.y)
        pinchScale = scale
      }
    })
    listen(imageContent, 'pointermove', event => {
      if (!touches.has(event.pointerId)) return
      touches.set(event.pointerId, { x: event.clientX, y: event.clientY })
      if (touches.size === 2 && pinchDistance > 0) {
        const [first, second] = [...touches.values()]
        scale = Math.min(5, Math.max(0.01, pinchScale * Math.hypot(first.x - second.x, first.y - second.y) / pinchDistance))
      } else if (touches.size === 1) {
        translateX = event.clientX - startX
        translateY = event.clientY - startY
      }
      updateTransform()
    })
    const endTouch = event => {
      touches.delete(event.pointerId)
      if (touches.size === 1) {
        const remaining = [...touches.values()][0]
        startX = remaining.x - translateX
        startY = remaining.y - translateY
      }
    }
    listen(imageContent, 'pointerup', endTouch)
    listen(imageContent, 'pointercancel', endTouch)
  }

  // 绑定按钮事件
  function initButtonEvents() {
    fitSwitchBtn.setAttribute('data-tooltip', modelTitle)
    
    listen(imageContent, 'click', () => { if (!isMobileViewer()) hideViewer() })
    listen(closeButton, 'click', hideViewer)
    listen(zoomInBtn, 'click', zoomIn)
    listen(zoomOutBtn, 'click', zoomOut)
    listen(fitSwitchBtn, 'click', fitSwitch)
    listen(rotateLeftBtn, 'click', rotateLeft)
    listen(rotateRightBtn, 'click', rotateRight)
    listen(downloadBtn, 'click', downloadImage)
    listen(previousButton, 'click', showPreviousImage)
    listen(nextButton, 'click', showNextImage)
    listen(retryButton, 'click', event => {
      event.stopPropagation()
      if (onRetry) onRetry()
      else showImageAt(currentImageIndex)
    })
  }

  // 绑定键盘事件
  function initKeyboardEvents() {
    function handleKeyDown(e) {
      if (overlay.style.display !== 'flex') return

      if (e.key === 'Tab') {
        const buttons = [...overlay.querySelectorAll('button')].filter(button => button.getClientRects().length)
        const first = buttons[0]
        const last = buttons[buttons.length - 1]
        if (first && (e.shiftKey ? document.activeElement === first : document.activeElement === last)) {
          e.preventDefault()
          ;(e.shiftKey ? last : first).focus()
        }
      }

      switch (e.key) {
        case 'Escape':
          // 图片预览先消费关闭键，避免同一次 Escape 继续关闭底层历史面板。
          e.preventDefault()
          e.stopImmediatePropagation()
          hideViewer()
          break
        case '+':
        case '=':
          zoomIn()
          break
        case '-':
          zoomOut()
          break
        case 'ArrowLeft':
          rotateLeft()
          break
        case 'ArrowRight':
          rotateRight()
          break
        case 'ArrowUp':
          if (viewerImages.length > 1) {
            e.preventDefault()
            showPreviousImage()
          }
          break
        case 'ArrowDown':
          if (viewerImages.length > 1) {
            e.preventDefault()
            showNextImage()
          }
          break
      }
    }

    listen(document, 'keydown', handleKeyDown, true)
  }

  // 监听窗口大小变化
  function initResizeHandler() {
    const resize = () => {
      if (overlay.style.display !== 'flex') return
      updateViewport()
      // 防抖处理
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        if (model === 1) { // 只在适应屏幕模式下重新计算
          fitToScreen()
        }
      }, 10)
    }
    listen(window, 'resize', resize)
    if (window.visualViewport) {
      listen(window.visualViewport, 'resize', resize)
      listen(window.visualViewport, 'scroll', resize)
    }
  }

  function normalizeViewerImages(sources) {
    const sourceList = Array.isArray(sources) ? sources : [sources]
    return sourceList
      .map(item => {
        if (typeof item === 'string') {
          return { src: item, downloadSrc: item }
        }
        if (!item || typeof item !== 'object') return null
        const src = item.src || item.url || item.previewUrl || ''
        if (!src) return null
        return {
          src,
          downloadSrc: item.downloadSrc || item.originalSrc || item.originalUrl || item.ossUrl || src
        }
      })
      .filter(Boolean)
  }

  function updateNavigationButtons() {
    const display = viewerImages.length > 1 ? 'flex' : 'none'
    previousButton.style.display = display
    nextButton.style.display = display
    overlay.classList.toggle('has-image-navigation', viewerImages.length > 1)
  }

  function showImageAt(index) {
    if (viewerImages.length === 0) return

    currentImageIndex = (index + viewerImages.length) % viewerImages.length
    const currentImage = viewerImages[currentImageIndex]
    currentImageSrc = currentImage.downloadSrc || currentImage.src
    initImageStatus(false)
    status.hidden = !isMobileViewer()
    statusText.textContent = viewerLabels.loading || ''
    retryButton.hidden = true
    let settled = false
    const loaded = () => {
      if (settled || overlay.style.display !== 'flex') return
      settled = true
      status.hidden = true
      fitToScreen()
      onLoad?.()
    }
    image.onload = loaded
    image.onerror = () => {
      if (settled || overlay.style.display !== 'flex') return
      settled = true
      setError(true)
      onError?.()
    }
    image.src = currentImage.src
    if (image.complete && image.naturalWidth > 0) {
      loaded()
    }
    onSwitch?.(currentImageIndex)
  }

  function showPreviousImage() {
    showImageAt(currentImageIndex - 1)
  }

  function showNextImage() {
    showImageAt(currentImageIndex + 1)
  }

  // 显示预览器，兼容单个 URL 和图片列表
  function showViewer(sources, initialIndex = 0) {
    viewerImages = normalizeViewerImages(sources)

    const normalizedIndex = Number.isInteger(initialIndex) ? initialIndex : 0
    if (overlay.style.display !== 'flex') {
      previousOverflow = document.body.style.overflow
      returnFocus = document.activeElement
    }
    overlay.style.display = 'flex'
    updateViewport()
    updateNavigationButtons()
    showImageAt(Math.min(Math.max(normalizedIndex, 0), viewerImages.length - 1))
    if (!viewerImages.length) {
      currentImageSrc = ''
      image.onload = null
      image.onerror = null
      image.removeAttribute('src')
      status.hidden = false
      statusText.textContent = viewerLabels.loading || ''
      retryButton.hidden = true
    }

    // 防止页面滚动
    document.body.style.overflow = 'hidden'
    closeButton.focus({ preventScroll: true })
  }

  function setError(failed) {
    if (!failed) return
    status.hidden = false
    image.removeAttribute('src')
    statusText.textContent = viewerLabels.failed || viewerLabels.fitToScreen
    retryButton.hidden = false
  }

  // 隐藏预览器
  function hideViewer() {
    if (overlay.style.display !== 'flex') return
    for (const pointerId of touches.keys()) {
      if (imageContent.hasPointerCapture?.(pointerId)) imageContent.releasePointerCapture(pointerId)
    }
    touches.clear()
    isDragging = false
    image.onload = null
    image.onerror = null
    initImageStatus()
    overlay.style.display = 'none'
    document.body.style.overflow = previousOverflow ?? ''
    previousOverflow = null
    viewerImages = []
    currentImageIndex = 0
    currentImageSrc = ''
    updateNavigationButtons()
    if (returnFocus?.isConnected) returnFocus.focus?.({ preventScroll: true })
    returnFocus = null
    
    // 调用关闭回调
    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  // 初始化所有事件
  initResizeHandler()
  initDragEvents()
  initButtonEvents()
  initKeyboardEvents()
  setLabels(viewerLabels)

  // 保存预览器实例到全局变量
  const viewer = {
    show: showViewer,
    hide: hideViewer,
    setLabels,
    setOnDownload,
    setError,
    element: overlay,
    destroy() {
      hideViewer()
      clearTimeout(resizeTimeout)
      listeners.forEach(remove => remove())
      image.onload = null
      image.onerror = null
      overlay.remove()
      style.remove()
      delete window[`imageViewer_${containerId}`]
    }
  }

  window[`imageViewer_${containerId}`] = viewer

  return viewer
}

// 创建默认的全局图片预览器
export function createGlobalImageViewer(options = {}) {
  return createImageViewer({
    ...options,
    containerId: options.containerId || 'global-image-viewer'
  })
}

// 销毁图片预览器
export function destroyImageViewer(containerId = 'global-image-viewer') {
  const viewer = window[`imageViewer_${containerId}`]
  if (viewer && viewer.element) {
    if (viewer.destroy) { viewer.destroy(); return }
    viewer.element.remove()
    delete window[`imageViewer_${containerId}`]
  }
}
